
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-excited/[level2]",
      function () {
        return require("private-next-pages/get-excited/[level2]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-excited/[level2]"])
      });
    }
  